import { Modal, Typography, Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';

const TrainingWorkoutInfoModal = ({ isOpen, onClose, workoutDetails }) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          maxWidth: '90vw',
          maxHeight: '80vh',
          overflowY: 'auto',
          margin: 'auto',
          marginTop: '100px',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Workout Details
        </Typography>
        <Grid container spacing={2}>
          {workoutDetails && workoutDetails.length > 0 ? (
            workoutDetails.map((detail, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Box sx={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
                  {detail.repetitions > 0 && <Typography><strong>Set Number:</strong> {detail.setNumber}</Typography>}
                  {detail.repetitions > 0 && <Typography><strong>Weight (kg):</strong> {detail.weightKg}</Typography>}
                  {detail.repetitions > 0 && <Typography><strong>Repetitions:</strong> {detail.repetitions}</Typography>}
                  {detail.distanceKm > 0 && <Typography><strong>Distance (km):</strong> {detail.distanceKm}</Typography>}
                  {detail.timeMinutes > 0 && <Typography><strong>Time (minutes):</strong> {detail.timeMinutes}</Typography>}
                  {detail.caloriesBurned > 0 && <Typography><strong>Calories Burned:</strong> {detail.caloriesBurned}</Typography>}
                  {detail.averageTempo > 0 && <Typography><strong>Average Tempo:</strong> {detail.averageTempo}</Typography>}
                </Box>
              </Grid>
            ))
          ) : (
            <Typography>No workout details available.</Typography>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

TrainingWorkoutInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  workoutDetails: PropTypes.array.isRequired
};

export default TrainingWorkoutInfoModal;
